import {RowGroup, RowGroupType} from '@common/models'

import {ComponentValue, Config, FileRowState} from './components/types'
import {PERSISTED_PLAN_FIELDS} from './planRecommendation'

export function buildScreeningRowGroups(
  config: Config,
  data: ComponentValue[],
  fileRows: Record<string, FileRowState>,
): {rowGroups: RowGroup[]; files: File[]} {
  const rowGroups: RowGroup[] = []
  const files: File[] = []

  Object.keys(config).forEach((cardTitle) => {
    config[cardTitle].forEach((entry) => {
      if (entry.component === 'NamedFileInput') {
        if (!entry.name) return
        const row = fileRows[entry.name]
        if (!row) return
        if (!row.fileId && !row.pendingFile) return
        const rowGroup: RowGroup = {
          type: RowGroupType.FILE,
          field: entry.name,
          fileName: row.pendingFile ? row.pendingFile.name : row.fileName,
          fileId: row.pendingFile ? undefined : row.fileId,
        }
        if (!rowGroup.field) {
          console.warn(`Missing field for NamedFileInput entry:`, entry)
          return
        }
        rowGroups.push(rowGroup)
        if (row.pendingFile) {
          files.push(row.pendingFile)
        }
      } else if (entry.component === 'PlanRecommendationInput') {
        PERSISTED_PLAN_FIELDS.forEach((field) => {
          const item = data.find((dataItem) => dataItem.name === field)
          if (item) {
            rowGroups.push({
              type: RowGroupType.FIELD,
              field: item.name,
              value: item.value,
            })
          }
        })
      } else if (entry.component !== 'PlaceHolder') {
        const item = data.find((d) => d.name === entry.name)
        if (item) {
          rowGroups.push({
            type: RowGroupType.FIELD,
            field: item.name,
            value: item.value,
          })
        }
      }
    })
  })

  return {rowGroups, files}
}
